/**
 * Set a value by a dot path.
 * Shameless sourced from: https://github.com/debitoor/dot-prop-immutable
 * @param obj The object to evaluate.
 * @param prop The path to be set.
 * @param val The value to set.
 */

export default function set(prop) {
  var path = prop = typeof prop === 'number' ? propToArray(prop.toString()) : typeof prop === 'string' ? propToArray(prop) : prop;
  return function (value) {
    return function (obj) {
      return setPropImmutableRec(obj, path, value, 0);
    };
  };
}
function setPropImmutableRec(obj, prop, value, i) {
  var clone = Object.assign({}, obj);
  var head = prop[i];
  if (prop.length > i) {
    clone[head] = setPropImmutableRec(obj[head] !== undefined ? obj[head] : {}, prop, value, i + 1);
    return clone;
  }
  return typeof value === 'function' ? value(obj) : value;
}
function propToArray(prop) {
  return prop.split('.').reduce(function (ret, el, index, list) {
    var last = index > 0 && list[index - 1];
    if (last && /(?:^|[^\\])\\$/.test(last)) {
      ret.pop();
      ret.push(last.slice(0, -1) + '.' + el);
    } else {
      ret.push(el);
    }
    return ret;
  }, []);
}